export enum AuthRoutePathsEnum {
  LOGIN = 'login',
  TELEKOM = 'telekom',
}
